import React from "react";
import { MainLayout } from "../../MainLayout";
import { ZimbabweSec1Data } from "../../../Data/IndiaSec1Data";
import { Footer } from "../../Footer";
import { IndiaSec4 } from "../India/IndiaSec4/IndiaSec4";
import { IndiaSec1 } from "../India/IndiaSec1/IndiaSec1";
import { IndiaSec2 } from "../India/IndiaSec2/IndiaSec2";
import { IndiaSec3 } from "../India/IndiaSec3/IndiaSec3";

export const Zimbabwe = () => {

    const destinationPackages = [
        {
            mapImg: "/assets/india-air.png",
            sliderimg: [
                { id: 1, img: "https://blueberrywebsites.azureedge.net/Dmc/Destination/zimbabwe-dest-1.webp", title: "Victoria Falls " },
                { id: 2, img: "https://blueberrywebsites.azureedge.net/Dmc/Destination/zimbabwe-dest-1.webp", title: "Zimbabwe River" },
            ],
            title: "3N/4D Victoria Falls Special ",
            days: "3N/4D",
            tags: ["WildLife", "Safari", "Bird Heaven"],
            description:
                "Upon arrival at Victoria Falls Airport, you will be warmly welcomed by our representative and transferred to your lodge on a shared SIC basis. After check-in, the rest of the day is free for you to relax or explore the area at your own pace. Enjoy the beautiful surroundings of Victoria Falls as you settle in for the start of your African adventure.",
            img: "https://blueberrywebsites.azureedge.net/Dmc/Destination/zimbabwe-dest-1.webp",
            slug: "victoriaSpecial",
        },
        {
            title: "3N/4D Harare City Sights & Safari Delights",
            days: "3N/4D",
            tags: ["WildLife", "Safari", "Bird Heaven"],
            description:
                "Upon your arrival at Harare International Airport, you will be warmly greeted and transferred in a private vehicle to your hotel in the city. After check-in, the remainder of the day is yours to relax at the hotel or explore Harare at your own pace. Whether you choose to unwind or take a stroll through the bustling streets of Zimbabwe’s capital, this first day sets the tone for an enriching journey ahead.",
            img: "https://blueberrywebsites.azureedge.net/Dmc/Destination/zimbabwe-dest-1.webp",
            slug: "harareSafari",
        },
        {
            title: "6N/7D Victoria Falls & Harare Discovery ",
            days: "6N/7D",
            tags: ["WildLife", "Safari", "Bird Heaven"],
            description:
                "Upon arrival at Victoria Falls Airport, you will be warmly welcomed by our representative and transferred to your lodge on a shared SIC basis. After check-in, the rest of the day is free for you to relax or explore the area at your own pace. Enjoy the beautiful surroundings of Victoria Falls as you settle in for the start of your African adventure.",
            img: "https://blueberrywebsites.azureedge.net/Dmc/Destination/zimbabwe-dest-1.webp",
            slug: "victoriaHarare",
        },
    ];

    const topcitydata = [
        {
            id: 1,
            title: "Harare",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Harare%20Zimbabwe.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Harare is the capital and largest city of
                    Zimbabwe, offering a vibrant cultural scene, beautiful gardens, and a
                    mix of urban and natural attractions. It’s an essential stop for
                    anyone looking to explore the heart of Zimbabwe’s modern life.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>National Gallery of Zimbabwe, Mbare
                    Market, Harare Gardens, Wild is Life Trust and Sanctuary{" "}
                </p>,
            ],
        },
        {
            id: 2,
            title: "Victoria Falls",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Zimbabawe%20top%20places/Zimbabawe%20top%20places/Victoria%20Falls.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Victoria Falls, known locally as
                    Mosi-oa-Tunya (The Smoke That Thunders), is one of the Seven Natural
                    Wonders of the World. This UNESCO World Heritage site is famous for
                    its breathtaking beauty and the surrounding adventure opportunities.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Victoria Falls, Bungee Jumping and
                    Bridge Swinging, Devil’s Pool, Zambezi River
                </p>,
            ],
        },
        {
            id: 3,
            title: "Bulawayo",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Bulawayo%20Zimbabwe.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Bulawayo is Zimbabwe's second-largest city
                    and an important cultural and industrial center. It’s known for its
                    historical significance, colonial architecture, and proximity to
                    natural attractions.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Matobo National Park, Natural
                    History Museum, Khami Ruins, Chipangali Wildlife Orphanage and
                    Research Centre
                </p>,
            ],
        },
        {
            id: 4,
            title: "Great Zimbabwe",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Great%20Zimbabwe.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Great Zimbabwe is an ancient city that was
                    once the capital of the Kingdom of Zimbabwe in the 11th to 15th
                    centuries. It’s an important archaeological site and a UNESCO World
                    Heritage site.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Great Zimbabwe Ruins, The National
                    Museum of Zimbabwe
                </p>,
            ],
        },
        {
            id: 5,
            title: "Hwange National Park",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Hwange%20National%20Park%20Zimbabwe.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Hwange is Zimbabwe's largest national park
                    and one of Africa’s most renowned wildlife reserves. It's famous for
                    its large elephant population and offers excellent game-viewing
                    opportunities.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Wildlife Viewing, Safari Activities,
                    Elephant Experience
                </p>,
            ],
        },
        {
            id: 6,
            title: "Lake Kariba",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Lake%20Kariba%20Zimbabwe.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Lake Kariba, one of the world’s largest
                    man-made lakes, offers a variety of recreational activities in a
                    serene, picturesque setting. It’s perfect for nature lovers and those
                    looking to relax or enjoy water-based activities.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Lake Cruises, Fishing and Water
                    Sports, Matusadona National Park
                </p>,
            ],
        },
        {
            id: 7,
            title: "Gonarezhou National Park",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/gonarezhou%20national%20park%20Zimbabwe.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Located in the southeastern part of
                    Zimbabwe, Gonarezhou is one of the country’s least visited yet most
                    beautiful national parks. It offers a sense of adventure and
                    exploration, with fewer crowds than other parks.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Game Drives, Chilojo , Walking
                    Safaris
                </p>,
            ],
        },
        {
            id: 8,
            title: "Mana Pools National Park",
            img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/Mana%20Pools%20National%20Park%20Zimbabwe.webp",
            desc: [
                <p>
                    <strong>Why Visit: </strong>Mana Pools, located along the Zambezi
                    River, is a UNESCO World Heritage site known for its stunning scenery,
                    abundant wildlife, and outstanding walking safari opportunities.
                </p>,
                <p>
                    <strong>Top Attractions: </strong>Walking Safaris, Game Drives and
                    Canoeing, Birdwatching
                </p>,
            ],
        },
    ];

    const data = [
        {
            id: 1,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon1.png",
            title: "Custom Zimbabwe Itineraries",
            desc: "Develop structured programs linking Victoria Falls with key safari regions like Hwange and Mana Pools, planned to manage internal travel time and seasonal conditions."
        },
        {
            id: 2,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon2.png",
            title: "Victoria Falls Experiences",
            desc: "Make Victoria Falls a central hub with access to both Zimbabwe and Zambia sides, including activities such as river cruises and aerial experiences tailored to different traveler profiles."
        },
        {
            id: 3,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon3.png",
            title: "Wildlife Safari Programs",
            desc: "Design safari stays in Hwange National Park with a focus on waterhole-based wildlife viewing, ensuring consistent sightings, especially during dry seasons."
        },
        {
            id: 4,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon4.png",
            title: "Walking & Canoe Safaris",
            desc: "Structure programs in Mana Pools National Park around walking safaris and canoeing along the Zambezi River, with seasonal access requiring advance planning."
        },
        {
            id: 5,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon5.png",
            title: "Heritage & Cultural Experiences",
            desc: "Integrate visits to Great Zimbabwe along with local community interactions to add historical and cultural depth to the journey."
        },
        {
            id: 6,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon6.png",
            title: "Lodge & Camp Planning",
            desc: "Offer a mix of safari lodges and camps across key regions, selected based on location, guiding quality, and overall guest experience."
        },
        {
            id: 7,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon7.png",
            title: "Seasonal Routing Considerations",
            desc: "Focus on routes with fewer crowds and better wildlife access, making them ideal for travelers seeking quieter, experience-led safaris."
        },
        {
            id: 8,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon8.png",
            title: "Regional Safari Combinations",
            desc: "Position Zimbabwe alongside Zambia, Botswana, or South Africa for extended safari circuits, enabling seamless multi-country travel programs."
        },
    ];

    return (
        <>
            <MainLayout bgImage={'url("https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/Destination/Zimbabwe%20Banner.webp")'}
                text2={"Zimbabwe"}
                button={true} />
            <IndiaSec1 IndiaSec1Data={ZimbabweSec1Data} />
            <IndiaSec2 countryCode="ZW" />
            <IndiaSec3 data={topcitydata} name={"Zimbabwe"} />
            <IndiaSec4
                data={data}
                heading={"Discover What We Bring to Zimbabwe "}
            />
            <Footer />

        </>
    )


};